import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[bodySection]',
    standalone: true,
})
export class BodySectionDirective {

  constructor(
    public viewContainerRef: ViewContainerRef
  ) { }

}
